module.exports = __webpack_public_path__ + "img/Maldives.4e197e1f.svg";